import { Utensils } from "lucide-react";
import { initials } from "@/components/ui/chef-avatar";

interface AssigneeBadgeProps {
  chefName: string | null;
  stationName: string | null;
}

/**
 * Who a recipe is assigned to, for the Chef column (YC-36): the chef, the
 * station, or the chef with the station beneath. Renders nothing when neither is
 * set, so the caller decides what "unassigned" looks like in its own row.
 */
export function AssigneeBadge({ chefName, stationName }: AssigneeBadgeProps) {
  if (!chefName && !stationName) return null;

  return (
    <div className="flex min-w-0 items-center gap-2">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[6px] bg-(--color-action)/10 text-xs font-semibold text-(--color-action)">
        {chefName ? initials(chefName) : <Utensils className="h-4 w-4" aria-hidden />}
      </div>
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-sm font-medium text-(--color-text-primary)">
          {chefName ?? stationName}
        </span>
        {chefName && stationName && (
          <span className="flex items-center gap-1 truncate text-xs text-(--color-text-secondary)">
            <Utensils className="h-3 w-3 shrink-0" aria-hidden />
            {stationName}
          </span>
        )}
      </div>
    </div>
  );
}
